import React, {Component} from 'react';

import './VideoSwapMenu.scss';

import closeIcon from '../../assets/icons/close.svg';
import VideoSelectionMenu from './videoSelectionMenu/VideoSelectionMenu';

class VideoSwapMenu extends Component {

	constructor(props) {
		super(props);

		this.state = {
			selectedVideoIndex: this.props.selectedVideoIndex
		}
	}

	componentDidUpdate(prevProps){
		if( prevProps.selectedVideoIndex !==  this.props.selectedVideoIndex &&  this.props.selectedVideoIndex !== this.state.selectedVideoIndex ){
			this.setState({
				selectedVideoIndex: this.props.selectedVideoIndex
			});
		}
	}

	shouldComponentUpdate(nextProps, prevState){
		return this.props.open !== nextProps.open || this.props.selectedVideoIndex !== nextProps.selectedVideoIndex || this.state.selectedVideoIndex !== prevState.selectedVideoIndex
	}

	/**
	 * When a new video is selected
	 * @param selectedVideoIndex
	 */
	onVideoSelectionChange = selectedVideoIndex => {
		this.setState({selectedVideoIndex});

		this.props.swapVideo(this.props.videos[selectedVideoIndex]);
		this.props.toggleOpen();
	};

	render() {
		return (
			<div className={`swapMenu ${this.props.open ? `swapMenu--open` : ``}`}>
				<div className={`swapMenu__header ${this.props.selectedVideoIndex === 0 ? `swapMenu__header--arrowLeft` : `swapMenu__header--arrowRight`}`}>
					<span className={`swapMenu__title`}>
						SELECT VISUAL
					</span>
					<img src={closeIcon} alt={`close`} className={`swapMenu__close`} onClick={this.props.toggleOpen} />
				</div>
				<div className={`swapMenu__content`}>
					<VideoSelectionMenu
						videos={this.props.videos}
						selected={this.state.selectedVideoIndex.toString()} // .toString() necessary because of lib bug
						onSelect={this.onVideoSelectionChange}
						open={this.props.open}
					/>
				</div>

			</div>
		)
	}
}

export default VideoSwapMenu;